import EmblaCarousel from "embla-carousel";
import ClassNames from "embla-carousel-class-names";
import generateToken from "@/utils/generateToken.js";

export default function (element, data) {
  let currentQuestionsSet = 1;
  const switchEl = element.querySelector(".switch");
  const switchHandle = switchEl.querySelector(".handle-picture");
  const nextButton = element.querySelector(".next-button");
  const startButton = element.querySelector(".start-button");
  const switchScreen = element.querySelector(".switch-screen");
  const questionsScreen = element.querySelector(".questions-screen");

  switchEl.addEventListener("mousedown", updateSwitchPosition);
  //switchEl.addEventListener("mousemove", updateSwitchPosition);
  switchEl.addEventListener("touchmove", function (event) {
    const touch = event.touches[0];
    const rect = switchEl.getBoundingClientRect();
    const layerX = touch.clientX - rect.left;

    updateSwitchPosition({
      buttons: 1,
      layerX: layerX
    });
  });
  window.addEventListener("mouseup", applySwitchPosition);
  window.addEventListener("touchend", applySwitchPosition);
  window.addEventListener("touchcancel", applySwitchPosition);

  
  function updateSwitchPosition(event) {
    if (event.buttons == 1) {
      const minX = window.innerWidth <= 800 ? 15 : 80;
      const maxX = window.innerWidth <= 800 ? switchEl.offsetWidth - 15 : switchEl.offsetWidth - 80;

      const x = Math.max(minX, Math.min(maxX, event.layerX));
      switchHandle.style.transform = `translateX(${x}px)`;
    }
  }

  function applySwitchPosition() {
    const x = parseFloat(switchHandle.style.transform.replace(/[^0-9.-]/g, ""));
    const switchRect = switchEl.getBoundingClientRect();

    const options = switchEl.querySelectorAll(".option");
    const positions = [];

    options.forEach((option, index) => {
      const optionRect = option.getBoundingClientRect();
      positions[index] = optionRect.left - switchRect.left;
    });

    const [roundedX, optionIndex] = positions.reduce(
      (closest, current, index) => {
        if (Math.abs(current - x) < Math.abs(closest[0] - x)) {
          return [current, index];
        }
        return closest;
      },
      [positions[0], 0],
    );

    switchHandle.style.transform = `translateX(${roundedX}px)`;
    currentQuestionsSet = optionIndex;
  }

  startButton.addEventListener("click", function () {
    element.querySelector(".screen.visible").classList.remove("visible");
    switchScreen.classList.add("visible");

    window.document.body.classList.add("started");
  });

  nextButton.addEventListener("click", function () {
    showQuestions(currentQuestionsSet);
    element.querySelector(".screen.visible").classList.remove("visible");
    questionsScreen.classList.add("visible");
  });

  let yesNum = 0;
  let noNum = 0;

  function showQuestions(questionsSet) {
    const viewport = questionsScreen.querySelector(".embla__viewport");
    const prevButton = questionsScreen.querySelector(".embla__prev");
    const nextButton = questionsScreen.querySelector(".embla__next");
    const currentSlidesClass = ".slide-group-" + (questionsSet + 1);

    yesNum = 0;
    noNum = 0;

    viewport.querySelectorAll(".embla__slide").forEach(function (slide) {
      if (slide.matches(currentSlidesClass)) {
        slide.classList.remove("hidden");
      } else {
        slide.classList.add("hidden");
      }
    });

    const emblaApi = EmblaCarousel(
      viewport,
      {
        //loop: true,
        align: "center",
        duration: 35,
        watchDrag: false,
        slides: currentSlidesClass,
        //dragFree: true,
      },
      [ClassNames()],
    );

    const cardButtonYes = questionsScreen.querySelectorAll(".card-button-yes");
    const cardButtonNo = questionsScreen.querySelectorAll(".card-button-no");

    cardButtonYes.forEach((button) => {
      button.addEventListener(
        "click",
        () => {
          yesNum++;
          if (emblaApi.canScrollNext()) {
            emblaApi.scrollNext();
          } else {
            showResult();
          }
        },
        false,
      );
    });

    cardButtonNo.forEach((button) => {
      button.addEventListener(
        "click",
        () => {
          noNum++;
          if (emblaApi.canScrollNext()) {
            emblaApi.scrollNext();
          } else {
            showResult();
          }
        },
        false,
      );
    });

    function showResult() {
      let result = 0;
      if (Math.abs(noNum - yesNum) < 2) {
        result = 2;
      } else if (yesNum > noNum) {
        result = 1;
      } else if (yesNum < noNum) {
        result = 3;
      }

      const token = generateToken(result);
      window.location.search = "?result=" + token;
    }
  }
}
